import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./i18n";
import App from "@/App";

const container = document.getElementById("root");

// Deliberately createRoot and not hydrateRoot, even though scripts/prerender.js
// fills #root at build time. framer-motion writes inline styles that depend on
// scroll position and animation progress, so the prerendered markup can never
// match React's first render; React 19 treats that as a failed hydration and
// falls back to a client render anyway, just noisier. Rendering fresh over the
// prerendered DOM happens in a single commit, and wasPrerendered (see
// src/lib/prerender.js) keeps above-the-fold content in its final state, so
// there is nothing to see between the static paint and the React one.
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
